import { Injectable } from '@angular/core';

import { HttpService } from '../http.service';
import { Observable, Subject } from '../util/rxjs';

export interface ProgressEvent {
  readonly type: 'progress';
  value: number;
}

export interface StartEvent {
  readonly type: 'start';
}

export interface FinishEvent {
  readonly type: 'finish';
}

export type LoadingBarEvent = ProgressEvent | StartEvent | FinishEvent;

@Injectable()
export class LoadingBarService {
  events$: Observable<LoadingBarEvent>;
  private userEventsStream = new Subject<LoadingBarEvent>();

  constructor(http: HttpService) {
    const startEvents = http.loadStart$.mapTo({ type: 'start' } as StartEvent);
    const finishEvents = http.loadEnd$.mapTo({ type: 'finish' } as FinishEvent);
    this.events$ = startEvents
      .merge(finishEvents)
      .merge(this.userEventsStream)
      .switchMap(event => this.processEvent(event));
  }

  setProgress(value: number) {
    this.userEventsStream.next({ type: 'progress', value })
  }

  startLoading() {
    this.userEventsStream.next({ type: 'start' });
  }

  finishLoading() {
    this.userEventsStream.next({ type: 'finish' });
  }

  private processEvent(event: LoadingBarEvent) {
    switch (event.type) {
      case 'start':
        return Observable.timer(0, 50).take(101)
          .map((_, value) => ({ type: 'progress', value } as ProgressEvent));
      default:
        return Observable.of(event);
    }
  }
}
